import React from 'react';
import { SortOption } from '../types';

interface SortControlsProps {
  sortBy: SortOption;
  onSortChange: (sort: SortOption) => void;
  plateCount?: number | null;
}

const SortControls: React.FC<SortControlsProps> = ({ sortBy, onSortChange, plateCount }) => {
  const sortOptions: { value: SortOption; label: string }[] = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'highest-rated', label: 'Highest Rated' },
    { value: 'lowest-rated', label: 'Lowest Rated' }
  ];

  return (
    <div className="w-full max-w-2xl bg-white dark:bg-slate-800/50 rounded-2xl border border-gray-200/60 dark:border-slate-700/50 shadow-soft dark:shadow-soft-dark p-3">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <div className="flex items-center gap-3 flex-wrap">
          {plateCount != null && (
            <>
              <span className="text-base font-bold text-gray-700 dark:text-slate-300">
                {plateCount.toLocaleString()} plate{plateCount !== 1 ? 's' : ''} shared
              </span>
              <span className="hidden sm:inline text-gray-300 dark:text-slate-600">·</span>
            </>
          )}
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-gray-500 dark:text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          <span className="text-sm font-medium text-gray-700 dark:text-slate-300">Sort by:</span>
          </div>
        </div>
        
        <div className="flex flex-wrap gap-2">
          {sortOptions.map(option => (
            <button
              key={option.value}
              onClick={() => onSortChange(option.value)}
              className={`px-3 py-1.5 rounded-xl text-sm font-medium transition-all duration-200 ${
                sortBy === option.value
                  ? 'bg-primary-500 text-white shadow-sm'
                  : 'bg-gray-100 dark:bg-slate-700/50 text-gray-700 dark:text-slate-300 hover:bg-gray-200 dark:hover:bg-slate-600/50'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SortControls;
